export default __webpack_public_path__ + "static/media/4.09845ebd.png";